module.exports = __webpack_public_path__ + "img/google-play-market.1f134b24.svg";